import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Generator } from "../../../components/Generator";
import { Grid } from "../../../components/Grid";
import { selectUserData } from "../../../components/appData.slice";
import { FormType } from "../../../components/enums";
//import { useShouldRedirectToHomepage } from "../../../hooks";
import { Url } from "../../../router/enums";
//import { selectIsFormValidated } from "../../../store/HOC/genericUI.selectors";
import { GenericPreload } from "../../GenericPreload";
import { GenericSummary, SummarySection } from "../../GenericSummary";
import { selectSummaryData as selectApplicantSummaryData } from "../Applicant/applicant.selectors";
import { selectSummaryData as selectIncidentSummaryData } from "../Incident/incident.selectors";
import {
  selectSummaryData as selectPerpetratorSummaryData,
  selectUIData,
} from "../Perpetrator/perpetrator.selectors";
import { selectSummaryData as selectVehicleSummaryData } from "../Vehicle/vehicle.selectors";

import { form } from "./form";

export const Summary = (): JSX.Element => {
  //JIRA LPPLWEBMOB-749
  const userData = useSelector(selectUserData);
  const { login, name, surname } = userData;
  const history = useHistory();
  const referrer = document.referrer;
  const isDirectEntry =
    history.action === "PUSH" && !referrer.includes(window.location.origin);

  if (!isDirectEntry && !login) {
    history.replace(Url.WELCOME);
  }
  //useShouldRedirectToHomepage(selectIsFormValidated(selectUIData));
  const vehicleStoreData = useSelector(selectVehicleSummaryData);
  const applicantStoreData = useSelector(selectApplicantSummaryData);
  const incidentStoreData = useSelector(selectIncidentSummaryData);
  const perpetratorStoreData = useSelector(selectPerpetratorSummaryData);

  return (
    <GenericSummary currentRoute={Url.AC_SUMMARY} formType={FormType.AC}>
      <SummarySection data={vehicleStoreData} title="Pojazd" />
      <SummarySection data={applicantStoreData.applicant} title="Zgłaszający" />
      <SummarySection data={applicantStoreData.driver} title="Kierujący" />
      <SummarySection
        data={applicantStoreData.otherPersons}
        title="Dane innych uczestników"
      />
      <SummarySection data={incidentStoreData} title="Zdarzenie" />
      <SummarySection data={perpetratorStoreData.perpetrator} title="Sprawca" />
      <SummarySection
        data={perpetratorStoreData.owner}
        title="Właściciel pojazdu"
      />
      <div className="MuiGrid-root SummarySection_container__3_WHs MuiGrid-container">
        <h2 className="MuiTypography-root spacingBottom_2 FormHeading_heading__1BJlb MuiTypography-h3">
          Klauzula Informacyjna
        </h2>
        <div className="MuiGrid-root SummaryRow_container__2zH1r MuiGrid-container">
          <div>
            Fleet Accident Management Services Sp. Z o.o. (FAMS) działa w
            imieniu Euro Insurances DAC
            <br />
            Administratorem danych osobowych przetwarzanych w ramach procesu
            ubezpieczeniowego jest Euro Insurances DAC adres: LeasePlan House,
            Ground Floor, Central Park, Leopardstown, Dublin 18, Irlandia.
            Wszelkie zapytania do Administratora możesz składać za pośrednictwem
            Fleet Accident Management Services Sp. z o.o. w formie: pisemnej na
            adres: ul. Postępu 14 B, 02-676 Warszawa – zgodnie z obowiązującą
            ustawą o Prawie pocztowym oraz elektronicznej - wyłącznie na adres:{" "}
            <a href="mailto:privacy-officer@fams.pl">privacy-officer@fams.pl</a>
            .
            <br />
            Pani/Pana dane osobowe będą przetwarzane w celach:
            <br />
            <ul>
              <li>
                realizacji umowy której Pan/Pani jest stroną na podstawie art.6
                ust 1 lit b) RODO
              </li>
              <li>
                wypełnienia obowiązku prawnego ciążącego na administratorze np.
                w przypadku rozliczeń podatkowych, obsługi szkód, odpowiedzi
                reklamacyjnych lub innych czynności umocowanych w innych
                podstawach prawnych na podstawie art.6 ust 1 lit c) RODO
              </li>
              <li>
                realizacji prawnie uzasadnionego interesu realizowanego przez
                administratora w przypadku dochodzenia lub obrony przed
                roszczeniami, bieżącego kontaktu oraz przesyłania danych
                osobowych do wewnętrznych celów administracyjnych na podstawie
                art.6 ust.1 lit f) RODO
              </li>
            </ul>
            <br />
            Odbiorcą Pana/Pani danych będą upoważnione podmioty na podstawie
            przepisów prawa oraz podmioty świadczące bieżące wsparcie
            Administratora danych np. usługi prawne, usługi IT.
            <br />
            Pana/Pani dane będą przetwarzany przez okres niezbędny do realizacji
            zgłoszenia/umowy oraz przez okres związany z przedawnieniem roszczeń
            wynikających na podstawie art 118 Kodeksu Cywilnego.
            <br />
            Ma Pani/Pan prawo zażądać wglądu, poprawy, aktualizacji,
            ograniczenia lub usunięcia przetwarzanych przez nas danych,
            sprzeciwić się ich przetwarzaniu lub jeśli chce Pani/Pan otrzymać
            elektroniczną kopię swoich danych osobowych w celu przekazania ich
            innej firmie (w zakresie, w jakim prawo do przenoszenia danych jest
            Pani/Panu przewidziane przez obowiązujące prawo), może się Pani/Pan
            z nami skontaktować za pośrednictwem formularza kontaktowego
            zamieszczonego na naszej stronie internetowej (
            <a href="https://www.leaseplan.com/pl-pl/">
              www.leaseplan.com/pl-pl/
            </a>
            ). Przysługuje Pani/Panu prawo wniesienia skargi do Prezesa Urzędu
            Ochrony Danych Osobowych, w sposób wskazany na stronie internetowej
            ww. organu pod adresem:{" "}
            <a href="https://www.uodo.gov.pl">www.uodo.gov.pl</a>, jeśli
            Pani/Pan uzna, iż przetwarzanie Pani/Pana danych osobowych narusza
            przepisy RODO.
            <br />
            Podanie Pana/Pani danych jest niezbędne do realizacji obsługi umowy
            lub sprawy z którą się Państwo kontaktują.
            <br />
            Pana/Pani dane nie podlegają zautomatyzowanym podejmowaniu decyzji,
            w tym o profilowaniu, o którym mowa w art. 22 ust. 1 i 4 RODO.
          </div>
        </div>
      </div>
      <Helmet>
        <script
          src="../../../DamageRegistrationForm/LPPL_Scripts/ShowSubmitButton.js"
          type="text/javascript"
        />
      </Helmet>
      <SummarySection data={perpetratorStoreData.car} title="Dane pojazdu" />
      <Generator
        form={form}
        render={(generatedForm) => (
          <Grid item xs={12}>
            {generatedForm}
          </Grid>
        )}
      />
      <GenericPreload form={FormType.AC} redirection={Url.AC_SENDING} />
    </GenericSummary>
  );
};
